import {
  color,
  elevation,
  flexCenter,
  noWrapHeight,
  noWrapSpacer,
  spacer,
  text,
  tinySpacer,
  truncateText,
} from '@tokens';
import { css } from '@emotion/react';
import type { SerializedStyles } from '@emotion/react';
import type { IconName } from '@components/Icon/BaseIcon';
import { ZINDEX } from '@utils/constants';
import type { NotificationKind } from './BaseNotification';

export const ICONS: { [key: string]: IconName } = {
  info: 'info',
  danger: 'warning',
  success: 'check',
  warning: 'warning',
  upsell: 'info',
};

export const BACKGROUND_COLORS: { [key: string]: string } = {
  info: color.bg_info,
  danger: color.bg_danger,
  success: color.bg_success,
  warning: color.bg_warning,
  upsell: '#e7ebf0', // legacy color for upsell. to be removed
};

export const BORDER_COLORS: { [key: string]: string } = {
  info: color.ui_border,
  danger: color.ui_border_danger,
  success: color.ui_border_success,
  warning: color.ui_border_warning,
};

export const baseNotificationStyles = css`
  display: flex;
  align-items: start;
  ${text('body2')}
  color: ${color.text_default};
`;

export const closeActionStyles = css`
  margin-left: ${spacer.x1};
`;

export const alertStyles = css`
  max-width: 600px;
  padding: ${spacer.x2} ${spacer.x3} ${spacer.x3};
`;

export const alertInnerStyles = css`
  flex-grow: 1;
  margin-right: ${spacer.x2};
  padding: 0 ${spacer.x1};
  hyphens: auto;
`;

export const alertActionStyles = css`
  align-self: start;
  white-space: nowrap;
  margin-right: ${spacer.x2};
`;

export const alertCloseActionStyles = css`
  margin-top: -${tinySpacer};
  margin-right: -${spacer.x0};
`;

export const bannerStyles = (kind: NotificationKind): SerializedStyles => css`
  height: ${noWrapHeight};
  padding: ${noWrapSpacer} ${spacer.x3};
  border-bottom: 1px solid ${BORDER_COLORS[kind] ?? 'transparent'};
`;

export const bannerInnerStyles = css`
  flex-grow: 1;
  ${flexCenter()}
  ${truncateText()}
`;

export const toastStyles = css`
  justify-content: center;
  max-width: 280px;
  height: ${noWrapHeight};
  padding: ${noWrapSpacer} ${spacer.x3};
  ${elevation(2)};
`;

export const fixedToastStyles = css`
  position: fixed;
  right: ${spacer.x4};
  z-index: ${ZINDEX.TOAST};
  // bottom positioning depending on css variable set by provider
  // formula is: base_margin + base_margin * index + toast_size * index
  bottom: calc(
    ${spacer.x4} + (${spacer.x4} * var(--toast-index)) +
      (${noWrapHeight} * var(--toast-index))
  );
`;
